/** Formats a B2B buyer user option for react-select. */
export const formatBuyerUserOption = (user) => user.nombre;
